import React from "react";
import { Box, InputBase, Typography } from "@mui/material";
import { tokens, monoFont } from "../../theme";

/**
 * Small bordered input box - label above, monospace value below - matching the mockup's
 * .mini-field. Several filter cards (Noise Reduction, Focus - Remove Worst, ...) used to share
 * MUI's underlined variant="standard" TextField instead, which reads as a different UI language
 * from the rest of the app. Built on InputBase rather than TextField so the box itself is fully
 * custom-styled instead of fighting TextField's outlined/standard/filled chrome.
 */
export default function MiniField({
    label, value, onChange, onBlur, inputMode = "numeric", maxLength, error, disabled, fullWidth,
}) {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: "3px",
            fontSize: "11px",
            color: tokens.muted,
            flex: fullWidth ? undefined : 1,
            width: fullWidth ? "100%" : undefined,
        }}>
            <Typography component="span" sx={{
                fontSize: "11px",
                color: tokens.muted,
                display: "flex",
                alignItems: "flex-end",
                minHeight: "2.4em",
                lineHeight: 1.15,
            }}>
                {label}
            </Typography>
            <InputBase
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                inputProps={{ inputMode, maxLength }}
                sx={{
                    fontFamily: monoFont,
                    fontSize: "13px",
                    backgroundColor: tokens.surface2,
                    border: `1px solid ${error ? tokens.reject : tokens.line}`,
                    borderRadius: tokens.radiusControl,
                    padding: "5px 8px",
                    color: tokens.text,
                    width: "100%",
                    "&.Mui-disabled": { opacity: 0.5 },
                    "& .MuiInputBase-input": { padding: 0 },
                }}
            />
        </Box>
    );
}
